import { useEffect } from "react";
import seo from "./pages.json";

const byPath = Object.fromEntries(seo.pages.map((p) => [p.path, p]));

function setAttr(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

// Keeps <title>, description, canonical and social tags in sync with the
// current route during client-side navigation. The same data is baked into
// per-route HTML at build time by scripts/prerender-meta.js.
export default function usePageMeta(pathname) {
  useEffect(() => {
    const page = byPath[pathname] || byPath["/"];
    const url = seo.siteUrl + (page.path === "/" ? "/" : page.path);

    document.title = page.title;
    setAttr('meta[name="title"]', "content", page.title);
    setAttr('meta[name="description"]', "content", page.description);
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('meta[property="og:title"]', "content", page.title);
    setAttr('meta[property="og:description"]', "content", page.description);
    setAttr('meta[name="twitter:url"]', "content", url);
    setAttr('meta[name="twitter:title"]', "content", page.title);
    setAttr('meta[name="twitter:description"]', "content", page.description);
  }, [pathname]);
}
